import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "../Pages/AuthPages/Login/Login";
import StudentOrgLogin from "../Pages/AuthPages/Login/StudentOrgLogin";
import PageNotFound from "../Exceptions/PageNotFound";
import NotAuthorized from "../Exceptions/NotAuthorized";
import RouteProtector from "./Layouts/IndexPageLayout";
import ForgotPassword from "../Pages/AuthPages/Forgot_Password/ForgotPassword";
import ResetPassword from "../Pages/AuthPages/Reset_Password/ResetPassword";
import Features from "../Components/Footer/Features";
import Pricing from "../Components/Footer/Pricing";
import Terms from "../Components/Footer/Terms";
import Privacy from "../Components/Footer/Privacy";
import Cookies from "../Components/Footer/Cookies";
import SystemStatus from "../Components/Footer/SystemStatus";
import CoverLayout from "../Pages/DataLayouts/CoverLayout";
import HelpCenterLayout from "../Pages/HelpCenter/HelpCenterLayout";
import HelpCenterHome from "../Pages/HelpCenter/HelpCenterHome";
import HelpSectionPage from "../Pages/HelpCenter/HelpSectionPage";

import FreeTrialPage from "../Pages/AuthPages/FreeTrailPage/TrialPage";
import OtpVerify from "../Pages/AuthPages/OtpVerify/OtpVerify";

import MyProfilePage from "../Pages/MyProfile/MyProfilePage";
import StudentProfilePage from "../Pages/StudentPortal/StudentProfilePage";
import StudentFeesPage from "../Pages/StudentPortal/StudentFeesPage";
import StudentCoursesPage from "../Pages/StudentPortal/StudentCoursesPage";
import StudentCatalogPage from "../Pages/StudentPortal/StudentCatalogPage";
import StudentAttendancePage from "../Pages/StudentPortal/StudentAttendancePage";
import StudentClassRecordsPage from "../Pages/StudentPortal/StudentClassRecordsPage";
import StudentAssignmentsPage from "../Pages/StudentPortal/StudentAssignmentsPage";
import StudentQuestionsPage from "../Pages/StudentPortal/StudentQuestionsPage";
import StudentTestPage from "../Pages/StudentPortal/StudentTestPage";
import ChangePassword from "../Pages/Settings/ChangePassword";
import UpdateCredentials from "../Pages/Settings/UpdateCredentials";
import OrganizationDetails from "../Pages/SignUpPages/OrganizationDetails";
import OrganizationAddInList from "../Pages/Orgnaization/Organisation/OrganizationAddInList";
import OrganizationProfile from "../Pages/Orgnaization/Profile/OrganizationProfile";
import OrganizationApplicationAccess from "../Pages/Orgnaization/Organisation/OrganizationApplicationAccess";
import {
  Configurations,
  getLeadActivityEmbedConfig,
} from "../Pages/EmsOptimized/FormConfigurations";
import CommonList from "../Pages/EmsOptimized/List/CommonList";
import ListPersonalizeView from "../Pages/EmsOptimized/List/ListPersonalizeView";
import CommonForm from "../Pages/EmsOptimized/Form/CommonForm";
import HomeEntry from "../Pages/HomeEntry";
import DashboardGate from "../Pages/DashBoard/DashboardGate";
import StudentDashboardPage from "../Pages/StudentPortal/StudentDashboardPage";
import LeadMonthlyFunnelReport from "../Pages/EmsOptimized/Reports/LeadMonthlyFunnelReport";
import CounsellorDashboard from "../Pages/EmsOptimized/CounsellorDashboard";
import {
  FollowupStructureForm,
  FollowupStructuresList,
} from "../Pages/EmsOptimized/FollowupStructuresPage";
import LeadActivitySnapshot from "../Pages/EmsOptimized/Reports/LeadActivitySnapshot";
import BatchClassAttendanceMarking from "../Pages/EmsOptimized/List/BatchClassAttendanceMarking";
import FeeDueReportMonthly from "../Pages/EmsOptimized/Reports/FeeDueReportMonthly";
import OfferRedemptionsPage from "../Pages/EmsOptimized/Offers/OfferRedemptionsPage";
import StudentAttendanceReport from "../Pages/EmsOptimized/Reports/StudentAttendanceReport";
import TrainingPortalPage from "../Pages/EmsOptimized/TrainingPortal/TrainingPortalPage";
import SendWhatsAppPage from "../Pages/EmsOptimized/Communications/SendWhatsAppPage";
import BatchCalendar from "../Components/BatchCalendar";
import SlotAvailability from "../Pages/Scheduling/SlotAvailability";
import TrainerSlotAvailability from "../Pages/Scheduling/TrainerSlotAvailability";
import RolePermissionList from "../Pages/User Management/RolePermission/RolePermissionList";
import RolePermissionForm from "../Pages/User Management/RolePermission/RolePermissionForm";
import ViewRolePermissionForm from "../Pages/User Management/RolePermission/ViewRolePermissionForm";
import ActivityLogList from "../Pages/User Management/ActivityLogs/ActivityLogList";
import EmailLogList from "../Pages/User Management/EmailLogs/EmailLogList";
import UserPermissionList from "../Pages/User Management/UserPermission/UserPermissionList";
import UserPermissionForm from "../Pages/User Management/UserPermission/UserPermissionForm";
import ViewUserPermissionForm from "../Pages/User Management/UserPermission/ViewUserPermissionForm";
import UserRoleList from "../Pages/User Management/UserRoles/UserRoleList";
import UserRoleForm from "../Pages/User Management/UserRoles/UserRoleForm";
import UserRolePersonalizeView from "../Pages/User Management/UserRoles/UserRolePersonalizeView";
import Users from "../Pages/Users/Users";
import ResourceUsersPage from "../Pages/Users/ResourceUsersPage";
import UsersAdd from "../Pages/Users/UsersAdd";
import UsersEdit from "../Pages/Users/UserEdit";
import UserPersonalizeView from "../Pages/Users/UserPersonalizeView";
import EmployeeList from "../Pages/EmployeeManagement/Employees/EmployeesList";
import EmployeePersonalizeView from "../Pages/EmployeeManagement/Employees/EmployeePersonalizeView";
import EmployeeExitList from "../Pages/EmployeeManagement/EmployeeExits/EmployeeExitList";
import EmployeeExitForm from "../Pages/EmployeeManagement/EmployeeExits/EmployeeExitForm";
import EmployeeExitPersonalizeView from "../Pages/EmployeeManagement/EmployeeExits/EmployeeExitPersonalizeView";
import DynamicFormPage from "../Pages/DataLayouts/DynamicFormPage";
import OrganizationAddInForm from "../Pages/Orgnaization/Organisation/OrganizationAddInForm";
import OrganizationEntityList from "../Pages/Orgnaization/OrganizationEntity/OrganizationEntityList";
import OrganizationEntityForm from "../Pages/Orgnaization/OrganizationEntity/OrganizationEntityForm";
import OrganizationLocationList from "../Pages/Orgnaization/Location/OrganizationLocationList";
import OrganizationLocationForm from "../Pages/Orgnaization/Location/OrganizationLocationForm";
import OrganizationLocationPersonalizeView from "../Pages/Orgnaization/Location/OrganizationLocationPersonalizeView";
import OrganizationDepartmentsList from "../Pages/Orgnaization/Department/OrganizationDepartmentsList";
import OrganizationDepartmentForm from "../Pages/Orgnaization/Department/OrganizationDepartmentsForm";
import OrganizationDepartmentsPersonalizeView from "../Pages/Orgnaization/Department/OrganizationDepartmentsPersonalizeView";
import OrganizationDesignationsList from "../Pages/Orgnaization/Designations/OrganizationDesignationsList";
import OrganizationDesignationsForm from "../Pages/Orgnaization/Designations/OrganizationDesignationsForm";
import OrganizationDesignationsPersonalizeView from "../Pages/Orgnaization/Designations/OrganizationDesignationsPersonalizeView";
import WorkShiftList from "../Pages/Time & Attendence/WorkShifts/WorkShiftList";
import WorkShiftForm from "../Pages/Time & Attendence/WorkShifts/WorkShiftForm";
import WorkShiftPersonalizeView from "../Pages/Time & Attendence/WorkShifts/WorkShiftPersonalizeView";
import MultiTableConfig from "../Pages/Orgnaization/DataGridSettings/MultiTableConfig";
import Reciept from "../Pages/EmsOptimized/List/Reciept";
import EmsPlansPage from "../Pages/Billing/EmsPlansPage";
import EmsBillingAccountPage from "../Pages/Billing/EmsBillingAccountPage";

// Routes
const router = createBrowserRouter([
  {
    path: "/billing",
    element: (
      <RouteProtector>
        <EmsBillingAccountPage />
      </RouteProtector>
    ),
  },
  {
    path: "/billing/plans",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <EmsPlansPage />,
      },
    ],
  },
  {
    path: "/start-free-trial",
    element: <FreeTrialPage />,
  },
  {
    path: "/start-free-trial/verify-otp",
    element: <OtpVerify />,
  },
  {
    path: "/start-free-trial/org-details",
    element: <OrganizationDetails />,
  },

  {
    path: "/login",
    element: <Login title={"Login"} />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword title={"Forgot Password"} />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword title={"Reset Password"} />,
  },
  {
    path: "/my-profile",
    element: (
      <RouteProtector>
        <MyProfilePage />
      </RouteProtector>
    ),
  },
  {
    path: "/student/profile",
    element: (
      <RouteProtector>
        <StudentProfilePage />
      </RouteProtector>
    ),
  },
  {
    path: "/student/dashboard",
    element: (
      <RouteProtector>
        <StudentDashboardPage />
      </RouteProtector>
    ),
  },
  {
    path: "/student/fees",
    element: (
      <RouteProtector>
        <StudentFeesPage />
      </RouteProtector>
    ),
  },
  {
    path: "/student/courses",
    element: (
      <RouteProtector>
        <StudentCoursesPage />
      </RouteProtector>
    ),
  },
  {
    path: "/student/catalog",
    element: (
      <RouteProtector>
        <StudentCatalogPage />
      </RouteProtector>
    ),
  },
  {
    path: "/student/attendance",
    element: (
      <RouteProtector>
        <StudentAttendancePage />
      </RouteProtector>
    ),
  },
  {
    path: "/student/class-records",
    element: (
      <RouteProtector>
        <StudentClassRecordsPage />
      </RouteProtector>
    ),
  },
  {
    path: "/student/assignments",
    element: (
      <RouteProtector>
        <StudentAssignmentsPage />
      </RouteProtector>
    ),
  },
  {
    path: "/student/assessments/:scheduleStudentId/test",
    element: (
      <RouteProtector>
        <StudentTestPage />
      </RouteProtector>
    ),
  },
  {
    path: "/student/questions",
    element: (
      <RouteProtector>
        <StudentQuestionsPage />
      </RouteProtector>
    ),
  },

  {
    path: "/reciept",
    element: <Reciept />,
  },



  {
    path: "/settings/change-password",
    element: (
      <RouteProtector>
        <ChangePassword />
      </RouteProtector>
    ),
  },
  {
    path: "/settings/update-credentials",
    element: (
      <RouteProtector>
        <UpdateCredentials />
      </RouteProtector>
    ),
  },

  {
    path: "/organization/switcher",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationAddInList />,
      },
    ],
  },
  {
    path: "/organization/application-access",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <OrganizationApplicationAccess />,
      },
    ],
  },

  {
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { path: "/", element: <HomeEntry /> },
      { path: "/dashboard", element: <DashboardGate /> },
      ...(Configurations?.filter(
      (item) =>
        item.route !== "/offer-redemptions" &&
        !String(item.route || "").startsWith("/offer-redemptions/")
    ).map((item) => {
    return {
      path: item.route,
      children: [
        {
          index: true,
          element: (
            <CommonList
              key={`${item.route}-list`}
              {...item.ListProps}
              addButtonLabel={item.FormProps?.headerProps?.addMessage}
            />
          ),
        },
        ...(item.ListProps?.readOnlyList
          ? []
          : [
              {
                path: "add",
                element: (
                  <CommonForm
                    key={`${item.route}-add`}
                    {...item.FormProps}
                    embeddedLeadActivityConfig={
                      item.route === "/leads"
                        ? getLeadActivityEmbedConfig()
                        : undefined
                    }
                  />
                ),
              },
              {
                path: "edit/:id",
                element: (
                  <CommonForm
                    key={`${item.route}-edit`}
                    {...item.FormProps}
                    embeddedLeadActivityConfig={
                      item.route === "/leads"
                        ? getLeadActivityEmbedConfig()
                        : undefined
                    }
                  />
                ),
              },
              {
                path: "view/:id",
                element: (
                  <CommonForm
                    key={`${item.route}-view`}
                    {...item.FormProps}
                    embeddedLeadActivityConfig={
                      item.route === "/leads"
                        ? getLeadActivityEmbedConfig()
                        : undefined
                    }
                  />
                ),
              },
            ]),
        ...(item.ListProps?.hidePersonalizeView
          ? []
          : [
              {
                path: "personalize-view",
                element: <ListPersonalizeView />,
              },
            ]),
      ],
    };
  })),
    ],
  },

  {
    path: "/followup-structures",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <FollowupStructuresList /> },
      { path: "add", element: <FollowupStructureForm /> },
      { path: "view/:id", element: <FollowupStructureForm readOnly /> },
      { path: "edit/:id", element: <FollowupStructureForm /> },
    ],
  },

  // Lead monthly funnel report (month filter + daily breakdown)
  {
    path: "/leads-monthly-funnel-report",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LeadMonthlyFunnelReport />,
      },
      {
        path: ":month",
        element: <LeadMonthlyFunnelReport />,
      },
    ],
  },

  {
    path: "/counsellor-report",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <CounsellorDashboard />,
      },
    ],
  },

  {
    path: "/lead-activities/snapshot/:leadId",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <LeadActivitySnapshot />,
      },
    ],
  },

  {
    path: "/batch-classes/attendance/:batchClassId",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <BatchClassAttendanceMarking />,
      },
    ],
  },

  {
    path: "/student-batch-calendar",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <BatchCalendar />,
      },
    ],
  },

  {
    path: "/slot-availability",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <SlotAvailability />,
      },
    ],
  },
  {
    path: "/trainer-slot-availability",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <TrainerSlotAvailability />,
      },
    ],
  },

  // Explicit Batch Trainers route (same behavior as dynamic Configurations map)
  {
    path: "/batch-trainers",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: (() => {
          const item = Configurations?.find((c) => c.route === "/batch-trainers");
          return item ? (
            <CommonList
              key="/batch-trainers-list"
              {...item.ListProps}
              addButtonLabel={item.FormProps?.headerProps?.addMessage}
            />
          ) : (
            <PageNotFound />
          );
        })(),
      },
      {
        path: "add",
        element: (() => {
          const item = Configurations?.find((c) => c.route === "/batch-trainers");
          return item ? <CommonForm key="/batch-trainers-add" {...item.FormProps} /> : <PageNotFound />;
        })(),
      },
      {
        path: "edit/:id",
        element: (() => {
          const item = Configurations?.find((c) => c.route === "/batch-trainers");
          return item ? <CommonForm key="/batch-trainers-edit" {...item.FormProps} /> : <PageNotFound />;
        })(),
      },
      {
        path: "view/:id",
        element: (() => {
          const item = Configurations?.find((c) => c.route === "/batch-trainers");
          return item ? <CommonForm key="/batch-trainers-view" {...item.FormProps} /> : <PageNotFound />;
        })(),
      },
    ],
  },

  // Explicit Class Records route (same behavior as dynamic Configurations map)
  {
    path: "/class-records",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: (() => {
          const item = Configurations?.find((c) => c.route === "/class-records");
          return item ? (
            <CommonList
              key="/class-records-list"
              {...item.ListProps}
              addButtonLabel={item.FormProps?.headerProps?.addMessage}
            />
          ) : (
            <PageNotFound />
          );
        })(),
      },
      {
        path: "add",
        element: (() => {
          const item = Configurations?.find((c) => c.route === "/class-records");
          return item ? <CommonForm key="/class-records-add" {...item.FormProps} /> : <PageNotFound />;
        })(),
      },
      {
        path: "edit/:id",
        element: (() => {
          const item = Configurations?.find((c) => c.route === "/class-records");
          return item ? <CommonForm key="/class-records-edit" {...item.FormProps} /> : <PageNotFound />;
        })(),
      },
      {
        path: "view/:id",
        element: (() => {
          const item = Configurations?.find((c) => c.route === "/class-records");
          return item ? <CommonForm key="/class-records-view" {...item.FormProps} /> : <PageNotFound />;
        })(),
      },
    ],
  },

  // Offers & redemptions report
  {
    path: "/offer-redemptions",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <OfferRedemptionsPage /> }],
  },

  // Fee due report (monthly)
  {
    path: "/fee-due-report",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <FeeDueReportMonthly /> },
      { path: ":year/:month", element: <FeeDueReportMonthly /> },
    ],
  },

  {
    path: "/training-portal",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <TrainingPortalPage /> }],
  },

  // Student attendance % report (all batches)
  {
    path: "/attendance-report",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <StudentAttendanceReport /> }],
  },

  // WhatsApp communications
  {
    path: "/communications/whatsapp",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <SendWhatsAppPage /> }],
  },

  // Employee Management
  {
    path: "/organization/employee/employee-details",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <EmployeeList /> },
      { path: "personalize-view", element: <EmployeePersonalizeView /> },
      { path: "add", element: <DynamicFormPage mode="add" /> },
      { path: "edit/:id", element: <DynamicFormPage mode="edit" /> },
      { path: "view/:id", element: <DynamicFormPage mode="view" /> },
    ],
  },
  {
    path: "/organization/employee/employee-exits",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <EmployeeExitList /> },
      { path: "personalize-view", element: <EmployeeExitPersonalizeView /> },
      { path: "add", element: <EmployeeExitForm mode="add" /> },
      { path: "edit/:id", element: <EmployeeExitForm mode="edit" /> },
      { path: "view/:id", element: <EmployeeExitForm mode="view" /> },
    ],
  },

  // Organization Setup
  {
    path: "/organization/details",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationAddInList /> },
      { path: "add", element: <OrganizationAddInForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationAddInForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationAddInForm mode="view" /> },
    ],
  },
  {
    path: "/organization/profile",
    element: (
      <RouteProtector>
        <OrganizationProfile />
      </RouteProtector>
    ),
  },
  {
    path: "/organization/entity",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationEntityList /> },
      { path: "add", element: <OrganizationEntityForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationEntityForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationEntityForm mode="view" /> },
    ],
  },
  {
    path: "/organization/location",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationLocationList /> },
      { path: "personalize-view", element: <OrganizationLocationPersonalizeView /> },
      { path: "add", element: <OrganizationLocationForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationLocationForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationLocationForm mode="view" /> },
    ],
  },
  {
    path: "/organization/departments",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationDepartmentsList /> },
      { path: "personalize-view", element: <OrganizationDepartmentsPersonalizeView /> },
      { path: "add", element: <OrganizationDepartmentForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationDepartmentForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationDepartmentForm mode="view" /> },
    ],
  },
  {
    path: "/organization/designation",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationDesignationsList /> },
      { path: "personalize-view", element: <OrganizationDesignationsPersonalizeView /> },
      { path: "add", element: <OrganizationDesignationsForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationDesignationsForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationDesignationsForm mode="view" /> },
    ],
  },
  {
    path: "/organization/work-shift",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <WorkShiftList /> },
      { path: "personalize-view", element: <WorkShiftPersonalizeView /> },
      { path: "add", element: <WorkShiftForm mode="add" /> },
      { path: "edit/:id", element: <WorkShiftForm mode="edit" /> },
      { path: "view/:id", element: <WorkShiftForm mode="view" /> },
    ],
  },
  {
    path: "/organization/data-grid-settings",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <MultiTableConfig /> }],
  },

  {
    path: "/users",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <Users /> },
      { path: "personalize-view", element: <UserPersonalizeView /> },
      { path: "add", element: <UsersAdd /> },
      { path: "edit/:id", element: <UsersEdit mode="edit" /> },
      { path: "view/:id", element: <UsersEdit mode="view" /> },
    ],
  },

  {
    path: "/resources/:roleSlug",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <ResourceUsersPage /> }],
  },

  {
    path: "/application/user-roles",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <UserRoleList /> },
      { path: "personalize-view", element: <UserRolePersonalizeView /> },
      { path: "add", element: <UserRoleForm mode="add" /> },
      { path: "edit/:id", element: <UserRoleForm mode="edit" /> },
      { path: "view/:id", element: <UserRoleForm mode="view" /> },
    ],
  },

  {
    path: "/application/user-role-permission",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <RolePermissionList />,
      },
      {
        path: "add",
        element: <RolePermissionForm mode="add" />,
      },
      {
        path: "view/:id",
        element: <ViewRolePermissionForm mode="edit" />,
      },
      {
        path: "edit/:id",
        element: <RolePermissionForm mode="edit" />,
      },
    ],
  },
  {
    path: "/application/activity-logs",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <ActivityLogList /> },
    ],
  },
  {
    path: "/application/email-logs",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <EmailLogList /> },
    ],
  },
  {
    path: "/application/user-permission",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <UserPermissionList />,
      },
      {
        path: "add",
        element: <UserPermissionForm mode="add" />,
      },
      {
        path: "view/:id",
        element: <ViewUserPermissionForm mode="edit" />,
      },
      {
        path: "edit/:id",
        element: <UserPermissionForm mode="edit" />,
      },
    ],
  },

  // Help Center (public)
  {
    path: "/help",
    element: <HelpCenterLayout />,
    children: [
      { index: true, element: <HelpCenterHome /> },
      { path: ":sectionSlug", element: <HelpSectionPage /> },
    ],
  },

  // footer
  {
    path: "/features",
    element: <Features />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/faq",
    element: <Navigate to="/help/faq" replace />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/cookies",
    element: <Cookies />,
  },
  {
    path: "/support",
    element: <Navigate to="/help/contact-support" replace />,
  },
  {
    path: "/system-status",
    element: <SystemStatus />,
  },
  {
    path: "/not-authorised",
    element: <NotAuthorized />,
  },
  {
    path: "/:orgSlug",
    element: <StudentOrgLogin />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);

export default router;
